import(/* webpackMode: "eager" */ "/vercel/path0/app/(site)/[locale]/[...slug]/error.tsx");
